import firebase from "../../firebase";

export default function({ couponId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "billingAdmin",
        funcName: "getCuponById",
        data: { couponId }
    });
}